module.exports = __webpack_public_path__ + "static/ebook_cover02-3005c05cd6ecf60a801c9d65f6e3ff39.jpg";